import BaseService from './base.service';

export default class BookingService extends BaseService {
    constructor(ctx) {
        super(ctx);
    }

    makeABooking = bookingData => {
        return this.post('/booking', bookingData);
    };
}
